/* eslint-disable */
import { types, getParent, flow } from "mobx-state-tree";
import { user, game as gameModule } from "@myplay/all";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";

import { CLIENT_UPLOAD, GCS_UPLOADING } from '../../utils/constants';

dayjs.extend(isBetween);

const notificationsModule = user.notifications;

const CHECK_ACTIVE_TASK_WHEN_ACTIVE = 5000;
const CHECK_ACTIVE_TASK_WHEN_NOT_ACTIVE = 20000;

const videoModule = gameModule.videos;

const clientUploadTask = types
  .model({
    type: CLIENT_UPLOAD,
    title: types.maybeNull(types.string),
    requestId: types.maybeNull(types.string),
    process: types.maybeNull(types.number)
  })
  .actions(self => ({
    setTaskProcess(process) {
      self.process = process;
    }
  }));

const ActiveTask = types.model({
  type: types.maybeNull(types.string),
  title: types.maybeNull(types.string),
  body: types.maybeNull(types.string),
  icon: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
  requestId: types.maybeNull(types.string)
});

const Notification = types.model({
  _id: types.identifier,
  isRead: types.boolean,
  title: types.string,
  stringType: types.string,
  action: types.frozen(),
  params: types.frozen(),
  icon: types.string,
  isSystem: types.boolean,
  sinceDate: types.string,
  body: types.maybeNull(types.string)
});

const NotificationsStore = types
  .model(`Notifications`, {
    unreadCount: types.maybeNull(types.number),
    notifications: types.maybeNull(types.array(Notification)),
    activeTasks: types.maybeNull(types.array(ActiveTask)),
    clientUploadTasks: types.maybeNull(types.array(clientUploadTask))
  })
  .actions(self => ({
    getNotifications: flow(function* getNotifications(userId = null, skip = 0) {
      try {
        const { UserStore } = getParent(self);
        
        if (!UserStore.data._id) {
          return;
        }

        const notifications = yield notificationsModule.getNotifications(
          UserStore.data._id,
          skip
        );
        
        if (skip > 0) {
          self.notifications.push(...notifications);
          return;
        }

        self.notifications = notifications || [];
      } catch (error) {
        console.log(error);
      }
    }),
    getActiveTasks: flow(function* getActiveTasks() {
      try {
        /* eslint-disable-next-line no-param-reassign */
        const { UserStore: { data: { _id } } } = getParent(self);
        const activeTasks = yield notificationsModule.getActiveTasks(_id);
        const gcsUploadingTasks = activeTasks.filter(
          task => task.status === GCS_UPLOADING
        );
        if (self.clientUploadTasks && self.clientUploadTasks.length > 0) {
          gcsUploadingTasks.map(async task => {
            if (
              self.clientUploadTasks.filter(
                item => item.requestId === task.requestId
              ).length === 0
            ) {
              await videoModule.updateUploadVideoRequest(
                task.requestId,
                "STOPPED_BY_USER"
              );
            }
          });
        } else {
          gcsUploadingTasks.map(task =>
            videoModule.updateUploadVideoRequest(
              task.requestId,
              "STOPPED_BY_USER"
            )
          );
        }
        self.activeTasks =
          activeTasks.filter(task => task.status !== GCS_UPLOADING) || [];
        
      } catch (error) {
        console.log(error);
      }
    }),

    getActiveTasksRecursive: flow(function* getActiveTasks() {
      try {
        yield self.getActiveTasks();
        const checkTaskInterval =
          self.activeTasks && self.activeTasks.length > 0
            ? CHECK_ACTIVE_TASK_WHEN_ACTIVE
            : CHECK_ACTIVE_TASK_WHEN_NOT_ACTIVE;

        setTimeout(() => {
          self.getActiveTasksRecursive();
          self.getNotifications();
          self.getUnreadCount();
        }, checkTaskInterval);
      } catch (error) {
        console.log(error);
      }
    }),
    getUnreadCount: flow(function* getUnreadCount() {
      try {
        const userId =
          getParent(self).UserStore.data && getParent(self).UserStore.data._id;

        if (!userId) {
          return;
        }

        const unreadCount = yield notificationsModule.getUnreadCount(userId);
        self.unreadCount = unreadCount;
      } catch (error) {
        console.log(error);
      }
    }),
    markAllAsRead: flow(function* markAllAsRead() {
      const userId =
        getParent(self).UserStore.data && getParent(self).UserStore.data._id;

      if (!userId) {
        return;
      }

      yield notificationsModule.markAllAsRead(userId);
      self.getUnreadCount();
    }),
    addClientUploadTasks(requestId, name) {
      if (!self.clientUploadTasks) {
        self.clientUploadTasks = [];
      }

      const title = `Uploading ${name}...`;

      const task = {
        requestId,
        title,
        process: 0
      };
      self.clientUploadTasks.push(task);
    },
    removeClientUploadTasks(requestId) {
      self.clientUploadTasks = self.clientUploadTasks.filter(
        task => task.requestId !== requestId
      );
    }
  }));

export default NotificationsStore;